import { defineMessages } from '@jutro/locale';

export default defineMessages({
    DocumentsWeSentYou: {
        id: 'ml.claim.views.ml-claim-details-docs-received.Documents We Sent You',
        defaultMessage: 'Documents We Sent You'
    }
});
